import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Quasar, Dialog, Notify } from 'quasar';
import router from './router';
import App from './App.vue';
import { authStorage } from './utils/authStorage';

// Import Quasar css
import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/dist/quasar.css';

// Import dialog fix CSS
import '../css/dialog-fix.css';

// Migrate any existing localStorage tokens to sessionStorage
authStorage.migrateFromLocalStorage();

// Check for authentication data from Laravel (after successful login)
if (window.__AUTH_DATA__) {
  const { token, user } = window.__AUTH_DATA__;
  if (token) {
    // Store the token in session storage for the auth store to use
    sessionStorage.setItem('token', token);
    // Store user data if available
    if (user) {
      sessionStorage.setItem('user', JSON.stringify(user));
    }
  }
  // Clean up the global variable
  delete window.__AUTH_DATA__;
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(Quasar, {
  plugins: {
    Dialog,
    Notify,
  },
});
app.use(router);

app.mount('#app');
